import type { FaireProductEntity } from "../../entity_types/product";

export const p_ysqjcct5ms: FaireProductEntity = {
  token: "p_ysqjcct5ms",
  type: "product",
  name: "Peanut Lil Bear- Organic Sherpa Knit Stuffed Animal Baby Toy",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl: "https://cdn.faire.com/fastly/be8aa8106976e2283821f8f0904a0e00cc4968f067398e0bfab37613e4a2612f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ff81f0c68bace512116f8cce6aec8073512267fb9c117d4375b58b3d22780cad.jpeg",
    "https://cdn.faire.com/fastly/060236fa440d924ab659d4dbdb3791a6ff8ccf8aeb12c714c6f192ff2601c13b.jpeg",
    "https://cdn.faire.com/fastly/7a3c0aad03425f5a47453518fa3dae74e5d28b7a2b23b855f757b83b45d7e561.jpeg",
    "https://cdn.faire.com/fastly/24217eec332c95194ea4c41f131bd467ae40a47b775f59ec3cc13c59a7ab93d9.jpeg",
    "https://cdn.faire.com/fastly/2370860d0c98eaa736a882d87f664c94a47d62b10be8172734cabb79b34ad83b.jpeg",
    "https://cdn.faire.com/fastly/044278a996e1b7d3dadf328bc1d4b5a90db8a1b34a52e9c4723496b5896954e1.jpeg",
    "https://cdn.faire.com/fastly/58b6df1d1c93a34c25c2f7683424a2a433d97372eddeb78b474bd9073a632f5b.jpeg",
    "https://cdn.faire.com/fastly/811fa9bbf2ff8d5f21dee2ad258aa211bd18332de5cddb297ed190cf10619ef6.jpeg",
    "https://cdn.faire.com/fastly/e02db93ececc0af4fb4fc2c9e0896d610de30336b95c2508013ef6c463d99113.jpeg",
    "https://cdn.faire.com/fastly/29b0e3b6237c9c38c6a211ab71a83515ecee5b34b78b0f25e8f9ce7234597554.jpeg",
    "https://cdn.faire.com/fastly/be70ba04f9f45859362dec663e34eb1f74002d543542654b44ff21346c273bd0.jpeg"
  ],
  priceDollars: 20,
  description: "Organic cotton sherpa knitted Peanut Lil Bear animal stuffed toys, soft and cuddly, comforting and soothing for your little ones.\nSize: Approx 11\" Tall\n100% organic cotton outer shell, and poly-fill on the inside.\n\nVIVERANO ORGANIC TOYS:\nQuirky & cuddly collection of organic cotton knit toys for your precious little ones.\nFresh & imaginative designs to bring joy and wonder to babies, kids and even adults.\nGreat for buddy adventures, good company and bedtime snuggles.\nLovingly made by hand using certified organic cotton, safe for hugging & snuggling.\nHeirloom quality, meticulous construction and attention to detail.\nNon-toxic and eco-friendly materials.\nSlight color variations & imperfections may exist making each handmade piece charming and one-of-a-kind.\nEasy care machine washable with cool water and non-toxic detergent, fluff in the dryer for a few minutes and then air dry.\nEthically handcrafted by artisans at a GOTS certified facility in India.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:02:28.824Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
